import { Link } from "react-router-dom";
import { Mark, Wordmark } from "@/components/ax/Mark";
import { useI18n } from "@/i18n";

export const HAK_KONTEN_COPY = {
  id: {
    title: "Hak konten",
    lede: "Bagaimana AXORIS menghormati hak cipta pada Executive Library.",
    s1t: "Teks orisinal AXORIS",
    s1p: "Sebagian besar bacaan di Pustaka adalah teks orisinal AXORIS. Anda boleh membaca, menandai, dan menyimpan catatan pribadi selama akun Anda berhak.",
    s2t: "Sumber terbuka yang dikurasi",
    s2p: "Sebagian edisi berasal dari sumber terbuka berlisensi. Setiap edisi melewati tinjauan hak manusia sebelum diterbitkan, lengkap dengan atribusi penulis, lisensi, dan tautan sumber.",
    s3t: "Yang tidak kami lakukan",
    s3p: "Kami tidak menjual, mengunduh ulang, atau mengklaim karya orang lain. Tautan keluar membuka situs pemilik hak, bukan salinan AXORIS.",
    s4t: "Menemukan pelanggaran?",
    s4p: "Jika Anda yakin sebuah edisi melanggar hak cipta, laporkan melalui formulir aduan. Setiap aduan ditinjau manusia; edisi yang terbukti melanggar diturunkan.",
    reportLink: "Laporkan pelanggaran hak cipta",
    back: "Kembali ke Pustaka",
  },
  en: {
    title: "Content rights",
    lede: "How AXORIS respects copyright in the Executive Library.",
    s1t: "Original AXORIS texts",
    s1p: "Most readings in the Library are original AXORIS texts. You may read, highlight, and keep personal notes while your account is entitled.",
    s2t: "Curated open sources",
    s2p: "Some editions come from licensed open sources. Every edition passes human rights review before publication, with author attribution, license, and source link.",
    s3t: "What we do not do",
    s3p: "We do not sell, re-host without rights, or claim the work of others. Outbound links open the rights holder site, not an AXORIS copy.",
    s4t: "Found a violation?",
    s4p: "If you believe an edition infringes copyright, report it through the report form. Every report is reviewed by a human; infringing editions are taken down.",
    reportLink: "Report a copyright violation",
    back: "Back to Library",
  },
};

export default function LegalHakKonten() {
  const { lang } = useI18n();
  const copy = HAK_KONTEN_COPY[lang === "en" ? "en" : "id"];
  return (
    <div className="min-h-screen bg-ax-bg px-4 py-8 text-ax-text">
      <main className="mx-auto w-full max-w-[720px]" data-testid="hak-konten-page">
        <Link to="/" aria-label="AXORIS" className="inline-flex items-center gap-3 text-ax-brand">
          <Mark size={24} />
          <Wordmark />
        </Link>
        <h1 className="type-h1 mt-8" data-testid="hak-konten-title">{copy.title}</h1>
        <p className="mt-4 text-sm leading-6 text-ax-text-2" data-testid="hak-konten-lede">{copy.lede}</p>

        <section className="mt-10">
          <h2 className="text-lg font-semibold">{copy.s1t}</h2>
          <div className="mt-3 space-y-3 text-sm leading-6 text-ax-text-2"><p>{copy.s1p}</p></div>
        </section>
        <section className="mt-10">
          <h2 className="text-lg font-semibold">{copy.s2t}</h2>
          <div className="mt-3 space-y-3 text-sm leading-6 text-ax-text-2"><p>{copy.s2p}</p></div>
        </section>
        <section className="mt-10">
          <h2 className="text-lg font-semibold">{copy.s3t}</h2>
          <div className="mt-3 space-y-3 text-sm leading-6 text-ax-text-2"><p>{copy.s3p}</p></div>
        </section>
        <section className="mt-10">
          <h2 className="text-lg font-semibold">{copy.s4t}</h2>
          <div className="mt-3 space-y-3 text-sm leading-6 text-ax-text-2"><p>{copy.s4p}</p></div>
          <p className="mt-4">
            <Link
              to="/legal/laporan-hak"
              data-testid="hak-konten-report-link"
              className="inline-flex min-h-[48px] items-center text-sm font-medium text-ax-link hover:underline"
            >
              {copy.reportLink}
            </Link>
          </p>
        </section>
      </main>
    </div>
  );
}
